export default "__VITE_ASSET__bFhCj0MI__"